<template>
  <sticky-header-layout>
    <featured-list-table
      :data="list"
      :is-loading="isLoading"
    />
  </sticky-header-layout>
</template>

<script>
import FeaturedListTable from './list/FeaturedListTable.vue'
import { getFeaturedItems } from '../../api/featured'

export default {
  name: 'FeaturedList',
  components: {
    FeaturedListTable,
  },
  data() {
    return {
      list: [],
      isLoading: false,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await getFeaturedItems()
        if (Array.isArray(response.data)) {
          this.list = response.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>

